import React, { useState, useEffect } from "react";
import { FaPlus, FaTimes } from "react-icons/fa";
import "./AddGuestListModal.css";

export default function AddGuestListModal({ isOpen, onClose, onSubmit, inviteeData, userType }) {

    const userData = JSON.parse(localStorage.getItem("userData"));

    const [category, setCategory] = useState("male");

    // const userData = { id: 13298 };

    // category is a prop like "Male" or "Female"
    const [rows, setRows] = useState([{ name: "", phone: "", user_id: userData?.id }]);

    useEffect(() => {
        if (isOpen) {
            // Reset rows when modal opens
            setRows([{ name: "", phone: "", user_id: userData?.id }]);
        }
    }, [isOpen]);

    // Add new row
    const handleAddRow = () => {
        setRows([...rows, { name: "", phone: "", user_id: userData?.id }]);
    };

    // Remove a row
    const handleRemoveRow = (index) => {
        const updated = [...rows];
        updated.splice(index, 1);
        setRows(updated.length ? updated : [{ name: "", phone: "", user_id: userData?.id }]);
    };

    // Handle input change
    const handleChange = (index, field, value) => {
        const updated = [...rows];
        updated[index][field] = value;
        setRows(updated);
    };

    // Submit
    const handleSubmit = (e) => {
        e.preventDefault();
        // Attach category to each guest
        const finalGuests = rows.map((r) => ({ ...r, category }));
        onSubmit(finalGuests);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="agl-overlay">
            <div className={`agl-modal ${category === "male" ? "male-bg" : "female-bg"}`}>
                {/* Header */}
                <div className="agl-header-model">
                    <h2>Add Guests <select className={` agl-gender-select ${category === "male" ? "male-text" : "female-text"}`} value={category} onChange={(e) => setCategory(e.target.value)} required>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                    </select></h2>
                    <button className="agl-close-btn" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>


                {/* Body */}
                <form onSubmit={handleSubmit} className="agl-form">
                    {rows.map((row, index) => (
                        <div key={index} className="agl-row">
                            <input
                                type="text"
                                placeholder="Guest Name"
                                value={row.name}
                                onChange={(e) => handleChange(index, "name", e.target.value)}
                                required
                            />
                            <input
                                type="tel"
                                placeholder="Phone Number"
                                value={row.phone}
                                onChange={(e) => handleChange(index, "phone", e.target.value)}
                                required
                            />
                            {rows.length > 1 && (
                                <button
                                    type="button"
                                    className="agl-remove-btn"
                                    onClick={() => handleRemoveRow(index)}
                                >
                                    <FaTimes />
                                </button>
                            )}
                        </div>
                    ))}

                    <button type="button" className="agl-add-btn" onClick={handleAddRow}>
                        <FaPlus /> Add Row
                    </button>




                    <div className="agl-actions">
                        <button type="submit" className="agl-submit-btn">
                            Save Guests
                        </button>
                    </div>
                    {inviteeData?.allowed_male > 0 &&
                        <span className="agl-allowed-note-text">You can add only {inviteeData?.allowed_male} Male Invitees</span>
                    }

                    {inviteeData?.allowed_female > 0 &&
                        <span className="agl-allowed-note-text">You can add only {inviteeData?.allowed_female} FemaleInvitees</span>
                    }
                </form>
            </div>
        </div>
    );
}
